import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import { enableElfProdMode } from "@ngneat/elf";
import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";
import { defineCustomElements } from "@ionic/pwa-elements/loader";

defineCustomElements(window);

if (environment.isProduction) {
	enableProdMode();
	enableElfProdMode();
}

platformBrowserDynamic()
	.bootstrapModule(AppModule)
	.catch((error) => console.error(error));
